import { useEffect } from "react";
import { Link } from "react-router-dom";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";
import { useLogSheet } from "../../contexts/LogSheetContext";
import { fireWrite } from "../../utils/offlineWrites";
import "./LoggedToast.css";

/** How long the toast stays up before the log is taken as meant. */
const UNDO_MS = 6000;

/**
 * "Logged Entered Line · Hagrid's — Open · Undo", after a one-tap log from
 * the Log sheet. Logging doesn't ask first; this is the way back instead.
 */
export function LoggedToast() {
  const { justLogged, dismissLogged } = useLogSheet();

  useEffect(() => {
    if (!justLogged) return;
    const id = window.setTimeout(dismissLogged, UNDO_MS);
    return () => window.clearTimeout(id);
  }, [justLogged, dismissLogged]);

  if (!justLogged) return null;
  const { interactionId, tripId, label } = justLogged;

  const undo = () => {
    dismissLogged();
    // Just made, so nothing is nested under it yet: removing it is the undo.
    fireWrite(deleteDoc(doc(db, "interactions", interactionId)), "undo of a new activity");
  };

  return (
    <div className="logged-toast" role="status">
      <span className="logged-toast-text">
        Logged <b>{label}</b>
      </span>
      <Link to={`/trips/${tripId}/interactions/${interactionId}`} className="logged-toast-open" onClick={dismissLogged}>
        Open
      </Link>
      <button type="button" className="logged-toast-undo" onClick={undo}>
        Undo
      </button>
    </div>
  );
}
